/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { StyledStack } from 'src/luis/verticals/getStartedGuide/components/GetStartedList';

const messages = defineMessages({
    publishItemBody: {
        id: 'portal.getStartedList.publishItemBody',
        defaultMessage: 'Once you\'ve trained, tested, and revised your app, you are ready to '
    },
    publishHyperLink: {
        id: 'portal.getStartedList.publishHyperLink',
        defaultMessage: 'Publish.'
    }
});

const urls = {
    publish: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-how-to-publish-app'
};

export const PublishListItem = () => {
    const { localize } = useLocalization();

    return (
        <StyledStack style={{ paddingLeft: 40 }}>
            <span>
                {localize(messages.publishItemBody)}
                <a href={urls.publish}>{localize(messages.publishHyperLink)}</a>
            </span>
        </StyledStack>
    );
};
